import React, { useMemo } from "react";
import EditModal from "../EditModal/EditModal";

const ACTIVE_OPTIONS = [
    { label: "Включен", value: true },
    { label: "Выключен", value: false },
];

const fileFromUploadValue = (v) => {
    const list = Array.isArray(v) ? v : [];
    const first = list[0];
    return first?.originFileObj || null;
};

const AddPromoModal = ({ open, onClose, onSubmit, confirmLoading = false, initialValues }) => {
    const fields = useMemo(
        () => [
            { type: "upload", name: "image", label: "Картинка", placeholder: "Выбрать изображение", props: { accept: "image/*", maxCount: 1 } },
            { type: "input", name: "title", label: "Заголовок", rules: [{ required: true, message: "Введите заголовок" }], props: { style: { width: "100%" } } },
            {
                type: "input",
                name: "description",
                label: "Описание (необязательно)",
                props: { style: { width: "100%" } },
            },
            {
                type: "select",
                name: "active",
                label: "Статус",
                options: ACTIVE_OPTIONS,
                rules: [{ required: true, message: "Выберите статус" }],
                props: { style: { width: "100%" } },
            },
        ],
        []
    );

    return (
        <EditModal
            open={open}
            title="Добавить промоакцию"
            onClose={onClose}
            confirmLoading={confirmLoading}
            okText="Создать"
            cancelText="Отмена"
            initialValues={initialValues || { active: false, image: [] }}
            fields={fields}
            onSubmit={(values) => {
                const payload = {
                    title: typeof values?.title === "string" ? values.title.trim() : "",
                    description: typeof values?.description === "string" ? values.description.trim() : "",
                    active: values?.active === true,
                    imageFile: fileFromUploadValue(values?.image),
                };
                onSubmit?.(payload);
            }}
        />
    );
};

export default AddPromoModal;